import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Badge from 'antd/lib/badge';
import Button from 'antd/lib/button';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';

import {
  ActionLink,
  DatasetItemDropdownStyle,
  DropdownTrigger,
  ListItem,
  LocationContainer,
  RemoveActionLink,
} from './styles';

const { Item } = Menu;

const handleActionClick = (callback, closeDropdown) => (event) => {
  event.preventDefault();
  closeDropdown();
  callback();
};

const ActionsMenu = ({
  openModal,
  destroyDataset,
  closeDropdown,
}) => (
  <Menu>
    <Item key="edit">
      <ActionLink href="/" onClick={handleActionClick(openModal, closeDropdown)}>
        Edit
      </ActionLink>
    </Item>
    <Item key="remove">
      <RemoveActionLink href="/" onClick={handleActionClick(destroyDataset, closeDropdown)}>
        Remove
      </RemoveActionLink>
    </Item>
  </Menu>
);

ActionsMenu.propTypes = {
  closeDropdown: PropTypes.func.isRequired,
  destroyDataset: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
};

const DatasetItemView = ({
  name,
  color,
  LocationsCount,
  destroyDataset,
  openModal,
  datapoints,
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const closeDropdown = () => setIsDropdownVisible(false);

  return (
    <>
      <DatasetItemDropdownStyle />
      <ListItem
        actions={[
          <Dropdown
            key="actions"
            overlay={(
              <ActionsMenu
                openModal={openModal}
                destroyDataset={destroyDataset}
                closeDropdown={closeDropdown}
              />
            )}
            trigger={['click']}
            placement="bottomRight"
            overlayClassName="map-dataset-actions-dropdown"
            visible={isDropdownVisible}
            onVisibleChange={setIsDropdownVisible}
          >
            <DropdownTrigger>
              <Button icon="ellipsis" />
            </DropdownTrigger>
          </Dropdown>,
        ]}
      >
        <div>
          <Badge color={color} />
          {name}
          <LocationContainer>
            <LocationsCount datapointsCount={datapoints.totalCount} />
          </LocationContainer>
        </div>
      </ListItem>
    </>
  );
};

DatasetItemView.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  destroyDataset: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  LocationsCount: PropTypes.func.isRequired,
  datapoints: PropTypes.object.isRequired,
};

DatasetItemView.defaultProps = {
  name: '',
  color: '',
};

export default DatasetItemView;
